import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static values = { model: String, elementId: String }

  onTagsUpdated(ev) {
    const relevant = ev.detail.model === this.modelValue
    const tagsUpdatedExternally = ev.detail.parentElementId !== this.elementIdValue

    if (relevant && tagsUpdatedExternally) {
      // Whenever tags are updated anywhere else in the page, we have to reload the
      // selected items to reflect the newly added/removed tags in the dropdown.
      this.element.controllers['select-multiple-component'].reloadSelectedItems()
    }
  }
}
